module.exports = __webpack_public_path__ + "static/media/hiburan.2bcda0ad.png";